import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommentBasicModel} from '@core/modules/rest/consent/response/comment-basic.model';

@Component({
    selector: 'app-comment-dialog',
    templateUrl: './comment-dialog.component.html',
    styleUrls: ['./comment-dialog.component.scss']
})
export class CommentDialogComponent {
    @Output() commentEvent: EventEmitter<string> = new EventEmitter();
    @Output() editEvent: EventEmitter<string> = new EventEmitter();
    dialogData: { title: string, comment?: CommentBasicModel };
    value: string;

    constructor(private dialog: MatDialogRef<CommentDialogComponent>, @Inject(MAT_DIALOG_DATA) data: { title: string, comment?: CommentBasicModel }) {
        this.dialogData = data;
        this.value = this.dialogData.comment?.content;
    }

    close(): void {
        this.dialog.close();
    }

    addNewComment(value: string): void {
        value = this.value?.trim();
        this.commentEvent.emit(value);
        this.close();
    }

    editComment(value: string): void {
        value = this.value?.trim();
        this.editEvent.emit(value);
        this.close();
    }

    onInputChanged($event: string): void {
        this.value = $event;
    }
}
